import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { numberWithSpaces } from '../../../utils/math';
import { AnimatedLink } from '../../../components/animated-link/AnimatedLink';

type Props = {
  decisionCount: number;
  allDecisionsLink: string;
};

export const FirmHeaderDecisionsLink: FC<Props> = ({
  decisionCount,
  allDecisionsLink,
}) => (
  <>
    {decisionCount > 0 && (
      <AnimatedLink
        href={allDecisionsLink}
        source="read_all_law_firm_decisions_from_header"
      >
        <span>
          <FormattedMessage
            id="header/FirmHeaderDecisionsLink.tsx/1"
            values={{
              count: decisionCount,
              countFormatted: numberWithSpaces(decisionCount),
            }}
          />
        </span>
      </AnimatedLink>
    )}
  </>
);
